import {Component, Input, OnInit} from '@angular/core';

import {AdType} from "@numizmat/enumerations";
import {AdCardComponent, AdCardData} from "@numizmat/components";

@Component({
  selector: 'nz-ad-form-step-04',
  imports: [
    AdCardComponent
  ],
  templateUrl: './ad-form-step-04.component.html',
  styleUrl: './ad-form-step-04.component.scss'
})
export class AdFormStep04Component implements OnInit {
  @Input() adCardData!: AdCardData;

  protected firstMockAdCardData!: AdCardData;
  protected secondMockAdCardData!: AdCardData;

  public ngOnInit(): void {
    const date: Date = new Date();

    this.firstMockAdCardData = {
      adId: 'mock-ad-01',
      title: '5 сантима 1879 година',
      imageUrl: 'https://collectoria.bg/assets/images/83b7e847-4bd1-4075-a63e-bf4dfb4c9202.webp',
      price: 130,
      adType: AdType.DirectSale,
      expiryDate: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 19
      ),
      additionalImageIds: ['1', '2']
    };

    this.secondMockAdCardData = {
      adId: 'mock-ad-02',
      title: '2 и 1/2 стотинки 1888 година',
      imageUrl: 'https://collectoria.bg/assets/images/2fc09c35-5931-4d3f-a389-6500170d4646.webp',
      price: 19,
      adType: AdType.Auction,
      expiryDate: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 13
      ),
      additionalImageIds: []
    };
  }
}
